import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import { Outlet } from "react-router-dom";
import "./Achievements.scss";

const achievements = [
  {
    headline: "Flipkart GRId 8.0",
    metric: "Semi-Finalist",
    meta: "Round 3 • 165,730 Registered Participants",
    text: "National Semi-Finalist at Flipkart GRId 8.0, advancing to Round 3 among 165,730 registered participants.",
  },
  {
    headline: "Ideaverse Hackathon",
    metric: "1st Place",
    meta: "Abhisarga Fest • 200+ Participants (50+ Teams)",
    text: "Ranked 1st as a team among 200+ participants (50+ teams) in the Ideaverse Hackathon during Abhisarga fest.",
  },
  {
    headline: "CodeChef Starters 206",
    metric: "Global Rank 70",
    meta: "Out of 2,843 Global Participants (Div 3)",
    text: "Secured Global rank 70 out of 2,843 global participants in CodeChef Starters 206 (Div 3).",
  },
  {
    headline: "LeetCode Contest 481",
    metric: "Top 3.10%",
    meta: "Rank 940 of 30,290 Global Participants",
    text: "Secured rank 940 (top 3.10%) out of 30,290 global participants in LeetCode Weekly Contest 481.",
  },
  {
    headline: "Competitive Coding",
    metric: "1400+ DSA",
    meta: "Knight (1909) • Pupil (1303) • 3 Star (1604)",
    text: "Competitive Coding: LeetCode max 1909 (Knight) | Codeforces max 1303 (Pupil) | CodeChef max 1604 (3 Star); solved 1400+ DSA problems across LeetCode, Codeforces, CodeChef, GFG, and Code360.",
  },
  // {
  //   headline: "Intra-Club Hackathon",
  //   metric: "3rd Place",
  //   meta: "Gradient Club, IIIT Sri City",
  //   text: "Placed 3rd as a team in the Intra-Club Coding Hackathon organized by the Gradient Club, IIIT Sri City.",
  // },
];

function Achievements() {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3300);
  }, []);

  return (
    <>
      <div className="container achievements-page">
        <div className="page">
          <span className="tags top-html">&lt;/html&gt;</span>
          <span className="tags top-tags">&lt;body&gt;</span>

          <div className="text-zone">
            <h1>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={[
                  "A",
                  "c",
                  "h",
                  "i",
                  "e",
                  "v",
                  "e",
                  "m",
                  "e",
                  "n",
                  "t",
                  "s",
                ]}
                idx={15}
              />
            </h1>
            {/* <div className="achievement-hero">
              <div className="achievement-hero-copy">
                <p className="hero-eyebrow">Competition / Hackathons / Consistency</p>
                <p className="hero-description">
                  A snapshot of the numbers behind the profile: ranks, contests,
                  and volume that make the achievements immediately visible.
                </p>
              </div>
              <div className="achievement-hero-stats">
                <div className="hero-stat">
                  <span className="hero-stat-value">1350+</span>
                  <span className="hero-stat-label">DSA solved</span>
                </div>
                <div className="hero-stat">
                  <span className="hero-stat-value">70</span>
                  <span className="hero-stat-label">CodeChef rank</span>
                </div>
                <div className="hero-stat">
                  <span className="hero-stat-value">Top 3.10%</span>
                  <span className="hero-stat-label">LeetCode contest</span>
                </div>
              </div> */}
            {/* </div> */}
          </div>

          <div className="achievements-grid">
            {achievements.map((item, index) => (
              <div
                className={`achievement-box ${item.highlighted ? ' highlighted' : ''}${index === achievements.length - 1 ? ' last-item' : ''}`}
                key={index}
                style={{ animationDelay: `${0.3 + index * 0.12}s` }}
              >
                <div className="box-metric-row">
                  <h3 className="box-headline">{item.headline}</h3>
                  <span className="box-metric">{item.metric}</span>
                </div>
                <p className="box-meta">{item.meta}</p>
                <p className="box-text"><strong>{item.text}</strong></p>
              </div>
            ))}
          </div>

          <Outlet />
          <span className="tags bottom-tags">
            &lt;/body&gt;
            <br />
            <span className="bottom-tag-html">&lt;/html&gt;</span>
          </span>
        </div>
      </div>
    </>
  );
}

export default Achievements;
